@if (!!searchResultPublication.isin) {
  <div class="security-title" otcxIsinToName [isin]="searchResultPublication.isin"
  data-test="security-name"></div>
}
<div class="publication-entry">
  <a href="{{searchResultPublication.file.path}}" target="_blank" data-test="link-to-publication" rel="noopener">
    <img alt="pdf" src="assets/ico-2d-dokument-pdf-01.svg">{{searchResultPublication.displayName}}</a>
    <span class="small"
    data-test="publication-date">{{searchResultPublication.publicationDate.toJSDate() | date}}</span>
  </div>
